import React from "react";
import Icon from "../../../components/AppIcon";
const SupplierNetwork = () => {
  const supplierTypes = [
    {
      type: "OEM Partners",
      count: "25+",
      icon: "Factory",
      description: "Direct partnerships with original equipment manufacturers",
      features: [
        "Genuine parts guarantee",
        "Factory warranties",
        "Latest model coverage",
      ],
    },
    {
      type: "Authorized Dealers",
      count: "150+",
      icon: "Store",
      description: "Certified dealer network across major Indian cities",
      features: ["Brand authorized", "Local inventory", "Quick delivery"],
    },
    {
      type: "Certified Aftermarket",
      count: "300+",
      icon: "Award",
      description: "Quality-certified aftermarket manufacturers",
      features: ["ISO certified", "Quality tested", "Cost-effective options"],
    },
  ];

  const qualityProcess = [
    {
      step: "01",
      title: "Authenticity Guaranteed",
      description: "Every part we sell is verified for OEM compatibility.",
      icon: "Check",
    },
    {
      step: "02",
      title: "Trusted Expertise",
      description: "A team of certified technicians and service professionals.",
      icon: "Shield",
    },
    {
      step: "03",
      title: "Nationwide Reach",
      description:
        "Supplying high-quality parts to workshops and customers across India.",
      icon: "Globe",
    },
    {
      step: "04",
      title: "Customer First",
      description:
        "Personalized guidance, transparent pricing, and fast delivery.",
      icon: "Text",
    },
  ];

  return (
    <section className="bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        {/* Quality Assurance Process */}
        <div className="bg-white rounded-2xl p-8 lg:p-12 shadow-automotive-lg border border-border mb-16">
          <div className="text-center mb-12">
            <h3 className="text-2xl lg:text-3xl font-bold text-text-primary mb-4">
              Quality Assurance Process
            </h3>
            <p className="text-text-secondary max-w-2xl mx-auto">
              Our rigorous 4-step verification process ensures every supplier
              and product meets our uncompromising standards for quality and
              authenticity.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {qualityProcess?.map((process, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-accent rounded-lg flex items-center justify-center mx-auto mb-4">
                    <Icon
                      name={process.icon}
                      size={24}
                      color="white"
                      strokeWidth={2}
                    />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 text-gray-300 rounded-full flex items-center justify-center text-3xl font-semibold">
                    {process.step}
                  </div>
                </div>
                <h3 className="text-lg font-semibold text-text-primary mb-2">
                  {process.title}
                </h3>
                <p className="text-sm text-text-secondary">
                  {process.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupplierNetwork;
